export default "__VITE_ASSET__bf28f7c4__"